var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGcp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.225 91.857l-16.074 16.074-.039.157a35.959 35.959 0 0 0 21.823 7.261h27.8V93.1h-27.8a13.82 13.82 0 0 1-5.71-1.243z",
    fill: "#34a853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.136 49.251a36.111 36.111 0 0 0-2.024 58.719l.039-.039 16.074-16.074.01-.01a13.9 13.9 0 1 1 18.388-18.388l16.124-16.124a35.941 35.941 0 0 0-48.611-8.084z",
    fill: "#fbbc05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.768 25.275l.031-.265a50.011 50.011 0 0 0-81.36 24.4 6.116 6.116 0 0 1 .7-.159A35.15 35.15 0 0 1 43 43.887c.109-.061.225-.155.315-.138A27.758 27.758 0 0 1 81.3 40.86h.268c-.07-.059-.119-.137-.19-.2z",
    fill: "#ea4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.1 49.41a50.135 50.135 0 0 0-15.106-24.361l-.226.226-15.39 15.39c.071.058.12.136.19.2a27.737 27.737 0 0 1 10 21.824v2.772a13.9 13.9 0 1 1 0 27.8h-27.8l-.039.04v22.057h-.118l.157.156h27.8A36.151 36.151 0 0 0 112.1 49.41z",
    fill: "#4285f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcp);
export default __webpack_public_path__ + "static/media/gcp.47c8ae82bd391b0794507c717456fc59.svg";
export { ForwardRef as ReactComponent };